import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload } from "../../common_types";
import { IntervalPayload } from "../types";

import { ConversionsWidgetActionTypes, ConversionsWidgetResponse } from "./types";

export const fetchRequest = (payload: IntervalPayload & GatePayload) =>
  action(ConversionsWidgetActionTypes.FETCH_REQUEST, payload);

export const fetchSuccess = (payload: ConversionsWidgetResponse) =>
  action(ConversionsWidgetActionTypes.FETCH_SUCCESS, payload);

export const fetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ConversionsWidgetActionTypes.FETCH_ERROR);
};

export const previousFetchRequest = (payload: IntervalPayload & GatePayload) =>
  action(ConversionsWidgetActionTypes.PREVIOUS_FETCH_REQUEST, payload);

export const previousFetchSuccess = (payload: ConversionsWidgetResponse) =>
  action(ConversionsWidgetActionTypes.PREVIOUS_FETCH_SUCCESS, payload);

export const previousFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ConversionsWidgetActionTypes.PREVIOUS_FETCH_ERROR);
};
